import { render, staticRenderFns } from "./CustomerFormExtraContacts.vue?vue&type=template&id=0073c43a&scoped=true&"
import script from "./CustomerFormExtraContacts.vue?vue&type=script&lang=js&"
export * from "./CustomerFormExtraContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0073c43a",
  null
  
)

export default component.exports